module.exports = __webpack_public_path__ + "static/media/Picture12.090e1ca2.png";